module.exports = __webpack_public_path__ + "img/all-africa.d7367cfb.png";